import AdminClient from '@/api/AdminClient';
import moment from 'moment';

export default class SessionsMetricsReport {
  constructor() {
    this.adminClient = null;
    this.schoolId = null;

    this.loading = false;
    this.error = null;

    this.parameters = {
      from: null,
      through: null,
      includeStatuses: [],
      customCampusTags: [],
    };
    this.data = {
      "requests":{"pending":0,"byStudentBeforeApproval":0,"approved":0,"declined":0,"inProgress":0},
      "canceled":{"byAdmin":0,"byStudent":0,"byStudentWithin24Hours":0,"byCounselor":0,"byCounselorWithin24Hours":0},
      "attended":{"both":0,"onlyStudent":0,"onlyCounselor":0,"neither":0},
      "uniqueStudents":0,
      "sessionCountHistogram":[]
    }
  }

  initialize($http, schoolId) {
    this.adminClient = new AdminClient($http);
    this.schoolId = schoolId;

    return this;
  }

  withCustomTags(tags) {
    this.parameters.customCampusTags = tags;

    return this;
  }

  asApprovedStatus() {
    this.parameters.includeStatuses = [
      'Upcoming'
    ];
    return this;
  }

  asAllStatuses() {
    this.parameters.includeStatuses = undefined;
    return this;
  }

  from(d) {
    if(d)
      this.parameters.from = d ? moment(d) : null;
    else
      this.parameters.from = null;
    
    return this;
  }
  
  through(d) {
    if(d)
      this.parameters.through = d ? moment(d) : null;
    else
      this.parameters.through = null;
    
    return this;
  }

  async getAllPast() {
    this.parameters.from = null;
    this.parameters.through = moment();

    await this.fetch();
  }

  async getLast30Days() {
    this.parameters.from = moment().add(-30, 'day');
    this.parameters.through = moment();

    await this.fetch();
  }

  async getUpcoming() {
    this.parameters.from = moment();
    this.parameters.through = null;

    await this.fetch();
  }

  async fetch() {
    try {
      this.loading = true;

      this.data = await this.adminClient.getCollegeAdminSessionsMetricsReport(
        this.schoolId,
        this.parameters.from,
        this.parameters.through,
        this.parameters.includeStatuses,
        this.parameters.customCampusTags
      );

      this.loading = false;
    } catch (error) {
      this.error = error;
    }
  }
}
